import { HTMLAttributes } from 'react';
import { joinClassNames } from '../../../utils';
import styles from './styles.module.scss';

export type RequiredIndicatorProps = HTMLAttributes<HTMLElement>;

export const RequiredIndicator = ({ className, ...props }: RequiredIndicatorProps) => (
  <abbr
    className={joinClassNames(styles.requiredIndicator, className)}
    title="required"
    aria-label="required"
    {...props}
  >
    *
  </abbr>
);
